import styled, {css} from 'styled-components';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';

import colors from '../../../styles/colors';
import { device } from '../../../styles/media';


export const StyledContainer = styled(Container)`
    height: 700px;
    padding-top: 100px;

    @media ${device.tablet}{
        padding-top: 2rem;
    }
`
export const StyledGrid = styled(Grid)`
    ${props => props.right_side && css`
    text-align: right;
    `}
`

export const StyledH2 = styled.h2`
    font-size: 2.5rem;
    text-align: center;
    font-weight: 400;
`

export const StyledInputBtn = styled.input`
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;    
    box-sizing: border-box; 
    border-radius: 25px;
    padding 1rem;
    text-decoration: none;
    color: white;
    margin-top: 1.0rem;
    background-color: ${colors.secondary};
    font-size: 1.0rem;
    border: none;
    width: 97%;
    transition: 0.5s;

    :focus{
        outline-width: 0;
    }

    ${props => props.primary && css`
        color: black;
        background-color: #ededed;
    `}

    ${props => props.submit && css`
        :hover{
            color: black;
            background-color: white;
            border: 1px solid black;
        }
    `}

    @media ${device.tablet}{
        width: 100%;       
    }
`

export const StyledTextArea = styled.textarea`
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;    
    box-sizing: border-box; 
    border-radius: 25px;
    padding 1rem;
    text-decoration: none;
    margin-top: 1.0rem;
    background-color: #ededed;
    font-size: 1.0rem;
    border: none;
    height: 8.0rem;
    width: 100%;

    :focus{
        outline-width: 0;
    }
`